module.exports = __webpack_public_path__ + "img/logo_1.5ce8c4b7.jpg";